import { render, staticRenderFns } from "./UpgradeFlair.vue?vue&type=template&id=5b4e0a7b&scoped=true"
import script from "./UpgradeFlair.vue?vue&type=script&lang=js"
export * from "./UpgradeFlair.vue?vue&type=script&lang=js"
import style0 from "./UpgradeFlair.vue?vue&type=style&index=0&id=5b4e0a7b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4e0a7b",
  null
  
)

export default component.exports